import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';

import reducers from './reducers.js';
import { debug } from '../constants/index.js';

export const configureStore = function ( initialState ) {

	// create compose
	const composeEnhancers = (
		( debug && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ) ?
			window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
				// Specify extension’s options like name, actionsDenylist, actionsCreators, serialize...
			}) :
			compose
	);

	// create middleware
	const loggerMiddleware = createLogger();

	// create store
	const store = createStore(
		reducers,
		initialState,
		composeEnhancers(
			applyMiddleware( loggerMiddleware )
		)
	);

	return store;

};